export default "__VITE_ASSET__O4WBRIj7__"